import ProfileModel from './profile-model';
import ProfileView from './profile-view';
import * as UIService from '../../services/ui-service';
import AuthService from '../../services/auth-service';
import ThemeService from '../../services/theme-service';

export default class ProfilePresenter {
  constructor(model, view, appInterface) {
    this.model = model || new ProfileModel();
    this.view = view || new ProfileView();
    this.appInterface = appInterface || {};
  }

  async init() {
    this.model.loadUserState();
    this.setupEventListeners();
    this.switchTab('account');
    this.updateUISettings();
  }

  setupEventListeners() {
    this.view.setupTabEventListeners((tabName) => this.switchTab(tabName));
    this.view.setupThemeEventListeners((theme) => this.changeTheme(theme));
    this.view.setupFontEventListeners((font) => this.changeFont(font));
    this.view.setupLogoutEventListener(() => this.logout());
    this.view.setupNotificationEventListener(() => this.toggleNotifications());
    this.view.setupLoginButtonEventListener(() => this.navigateToAuth());
  }

  switchTab(tabName) {
    this.view.switchTab(tabName);
    
    if (tabName === 'account') {
      this.renderAccountPanel();
    }
    
    this.appInterface.reinitTooltips();
  }

  renderAccountPanel() {
    const userData = this.model.getUserData();
    this.view.renderAccountPanel(userData);
  }

  changeTheme(theme) {
    const success = this.model.updateTheme(theme);
    
    if (success) {
      this.view.updateThemeSettings(theme);
      if (this.appInterface.setTheme) {
        this.appInterface.setTheme(theme);
      };
      this.appInterface.showToast(`Tema berubah ke ${theme === 'dark' ? 'gelap' : 'terang'}`, 'success');
    }
  }
  
  changeFont(font) {
    const success = this.model.updateFont(font);
    
    if (success) {
      this.view.updateFontSettings(font);
      if (this.appInterface.setFont) {
        this.appInterface.setFont(font);
      }

      const fontName = font === 'disleksia' ? 'ramah disleksia' : 'bawaan';
      this.appInterface.showToast(`Font berubah ke ${fontName}`, 'success');
    }
  }

  toggleNotifications() {
    if (!this.model.isAuthenticated) {
      if (this.appInterface.showToast) {
        this.appInterface.showToast('Masuk terlebih dahulu untuk mengaktifkan notifikasi', 'warning');
      }
      return;
    }

    const isSubscribed = this.model.isPushSubscribed();

    if (isSubscribed) {
      this.appInterface.unsubscribeFromNotifications();
    } else {
      this.appInterface.enableNotifications();
    }
  }

  logout() {
    this.appInterface.showConfirmDialog(
      'Yakin ingin keluar?',
      () => {
        const success = this.model.logout();
        
        if (success) {
          if (this.appInterface.setAuthState) {
            this.appInterface.setAuthState(false, {}, null);
          }
          this.appInterface.navigateTo('home');
          this.appInterface.showToast('Berhasil keluar', 'success');
        }
      }
    );
  }

  navigateToAuth() {
    this.appInterface.navigateTo('auth');
  }

  updateUISettings() {
    const currentTheme = this.model.getCurrentTheme();
    const currentFont = this.model.getCurrentFont();
    const isSubscribed = this.model.isPushSubscribed();
    
    this.view.updateThemeSettings(currentTheme);
    this.view.updateFontSettings(currentFont);
    this.view.updateNotificationButton(isSubscribed);
  }

  updateNotificationButton(isSubscribed) {
    this.model.setPushSubscription(isSubscribed ? {} : null);
    this.view.updateNotificationButton(isSubscribed);
  }

  refresh() {
    this.model.loadUserState();
    this.renderAccountPanel();
    this.updateUISettings();
  }

  cleanup() {
    this.view.cleanup();
  }
}